import { render, staticRenderFns } from "./OrcamentoStatus.vue?vue&type=template&id=8005328a"
import script from "./OrcamentoStatus.vue?vue&type=script&lang=js"
export * from "./OrcamentoStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports